import { compose, filter, identity, isEmpty, map, propOr, split } from 'ramda'

import { useQueryParams } from '../../../../../utils/contexts/UrlProvider'

const formatFilter = (qp, key) => {
  const values = compose(
    map(value => ({ value: parseInt(value) })), //
    filter(identity),
    split(','),
    propOr('', key)
  )(qp)

  if (isEmpty(values)) return {}
  return { [key]: values }
}

export const useUrlFilters = () => {
  const qp = useQueryParams()

  const filterObj = {
    ...formatFilter(qp, 'userIds'),
    ...formatFilter(qp, 'entityUserIds'),
    ...formatFilter(qp, 'entityFormIds'),
    ...formatFilter(qp, 'entitySegmentIds'),
    ...formatFilter(qp, 'entityChecklistIds'),
    ...formatFilter(qp, 'entityServiceOrderIds'),
    ...formatFilter(qp, 'entityPlaceIds'),
    ...formatFilter(qp, 'entityTriggerIds')
  }

  if (isEmpty(filterObj)) return {}
  return { filter: filterObj, tempFilter: filterObj }
}
